"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

var _CssParser = _interopRequireDefault(require("../CssParser"));

var _KeyGen = require("../KeyGen");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  max-width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .svg {\n    box-sizing: border-box;\n    max-width: 100%;\n    height: auto;\n  }\n\n  .hw-svg-built {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Root = _styledComponents.default.span(_templateObject(), function (props) {
  return props.recolor ? "\n      stroke: ".concat(props.theme.colorNeutral, ";\n      fill: ").concat(props.theme.colorNeutral, ";\n    ") : '';
});

var Image = _styledComponents.default.img(_templateObject2());

var SvgImage = /*#__PURE__*/function (_Component) {
  _inherits(SvgImage, _Component);

  function SvgImage() {
    _classCallCheck(this, SvgImage);

    return _possibleConstructorReturn(this, _getPrototypeOf(SvgImage).apply(this, arguments));
  }

  _createClass(SvgImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          alt = _this$props.alt,
          recolor = _this$props.recolor;

      if (new RegExp('^https?://.*\\.svg$').test(this.props.src)) {
        var wrapper = this.imageWrapper;

        if (wrapper) {
          fetch(this.props.src, {
            method: 'get',
            mode: 'cors',
            cache: 'no-store'
          }).then(function (response) {
            return response.text();
          }).then(function (text) {
            var Parser = new DOMParser();
            var doc = Parser.parseFromString(text, 'text/xml');
            var svg = doc.querySelector('svg');
            var img = wrapper.querySelector('img');
            var styleMap = {};

            if (svg && img) {
              svg.setAttribute('class', 'svg');

              if (alt) {
                svg.setAttribute('role', 'img');
                svg.setAttribute('aria-label', alt);
              } else {
                svg.setAttribute('role', 'presentation');
                svg.setAttribute('focusable', 'false');
              } // Remove all non-none color from svg to make it easier to overwrite color without losing any other style data


              var styleNode = svg.querySelector('style');
              if (styleNode) styleNode.setAttribute('aria-hidden', true);

              if (recolor && styleNode) {
                var styleParser = new _CssParser.default();
                var textSelector = styleNode.innerHTML ? 'innerHTML' : 'textContent';
                var styleHtml = styleNode[textSelector] || '';
                var styleJson = styleParser.parse(styleHtml) || [];
                var workingJson = styleJson.slice(0);

                for (var index = 0; index < workingJson.length; index++) {
                  // Renaming svg class names to avoid name collisions across multiple svg elements
                  var declaration = workingJson[index];

                  if (declaration.selector.indexOf('.') === 0) {
                    var newSelector = declaration.selector + '_' + (0, _KeyGen.getKey)();
                    styleMap[declaration.selector] = newSelector;
                    styleJson[index].selector = newSelector;
                  } // Apply new rules for fill and stroke so these properties can be overwritten


                  var hasStroke = false;

                  for (var ri = 0; ri < declaration.rules.length; ri++) {
                    var rule = declaration.rules[ri];

                    if (rule.directive === 'stroke') {
                      hasStroke = true;
                    }

                    if (rule.directive === 'fill' || rule.directive === 'stroke') {
                      if (rule.value === 'none') {
                        styleJson[index].rules[ri].value = 'none !important';
                      } else {
                        styleJson[index].rules[ri].value = 'inherit';
                      }
                    }
                  }

                  if (!hasStroke) {
                    styleJson[index].rules[declaration.rules.length] = {
                      directive: 'stroke-width',
                      value: '0'
                    };
                  }
                }

                styleNode[textSelector] = styleParser.compose(styleJson);
              }

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = svg.querySelectorAll('[class]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var classElement = _step.value;
                  var className = classElement.getAttribute('class'); // Use new class name if one exists

                  if (styleMap[".".concat(className)]) {
                    className = styleMap[".".concat(className)].substr(1);
                  }

                  classElement.setAttribute('class', "".concat(className, " hw-svg-built"));
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              wrapper.replaceChild(svg, img);
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          src = _this$props2.src,
          alt = _this$props2.alt,
          additionalClassName = _this$props2.additionalClassName,
          children = _this$props2.children,
          recolor = _this$props2.recolor,
          theme = _this$props2.theme,
          otherProps = _objectWithoutProperties(_this$props2, ["src", "alt", "additionalClassName", "children", "recolor", "theme"]);

      if (children || recolor) {// Peeled off invalid image attributes
      }

      return _react.default.createElement(Root, {
        className: (0, _classnames.default)('hw-structured-image-wrapper', additionalClassName),
        ref: function ref(wrapper) {
          _this.imageWrapper = wrapper;
        },
        recolor: recolor,
        theme: theme
      }, _react.default.createElement(Image, _extends({
        className: "hw-image",
        src: src,
        alt: alt
      }, otherProps)));
    }
  }]);

  return SvgImage;
}(_react.Component);

SvgImage.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string,
  additionalClassName: _propTypes.default.string,
  recolor: _propTypes.default.bool,
  children: _propTypes.default.node,
  theme: _propTypes.default.shape({
    colorNeutral: _propTypes.default.string
  })
};
SvgImage.defaultProps = {
  alt: '',
  recolor: true,
  additionalClassName: null,
  children: null,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(SvgImage);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/SvgImage/index.js